<template>
  <data-section
    v-if="!_.isEmpty(proccessDatas)"
    style="font-size: 15px"
    theme="green"
    title="國泰人壽保單"
    :isLoading="isLoading"
    :datas="proccessDatas"
    :_fields="
      [
        {
          name: '保單號碼\n險種',
          key: 'productname',
          width: 174,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'insuredpersonname',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortInsuredpersonname'],
          orderByMultiType: ['asc']
        },
        {
          name: '繳費\n年期',
          key: 'year',
          width: 55,
        },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 49,
          thClassName: 'text-left',
          className: 'text-left'
        },
        {
          name: '投保始期',
          key: 'insurancedate',
          width: 95,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc']
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right',
         /* sortable: true,
          orderByMultiKey: ['amountofinsurance'],
          orderByMultiType: ['asc'] */
        },
        {
          name: '下期應繳保費\n繳別/繳費方式',
          key: 'bknm',
          width: 138,
          thClassName: 'text-right',
          className: 'text-right',
          sortable: true,
          orderByMultiKey: ['sortBknm'],
          orderByMultiType: ['asc']
        },
        { name: '受益人', key: 'bnf', width: 151 },
        {
          name: '契約狀態',
          key: 'isprimarycontract',
          sortable: true,
          width: 99,
          orderByMultiKey: ['sortIsprimarycontract'],
          orderByMultiType: ['asc']
        }
      ].concat(_fields)
    "
    @toggle="
      (isShow) => $router.assignQuery({ CathayLifeInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayLifeInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        class="mt-2"
        v-bind="
          Object.assign({}, props, {
            datas: props.datas
          })
        "
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`CathayLifeInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`CathayLifeInsuranceSort`]
            ? JSON.parse($route.query[`CathayLifeInsuranceSort`])
            : {
                key: ['sortInit'],
                type: ['asc']
              }
        "
      >
        <template slot="productname" scope="item">
          <div v-if="item.data.isPrimaryContract">
            <div class="font-13" :class="{ policyBlue: item.data.b015plcno }">
              {{ item.data.policynumber }}
            </div>
            <div>{{ item.data.productname }}({{ item.data.prodid }})</div>
            <div v-if="item.data.ceplcvl">
              <span style="color: #ffa500">
                保單價值：
                {{ item.data.money == "NTD"? "" : item.data.money }}
                {{ Number(item.data.ceplcvl) | numberFormat3 }}
              </span>
            </div>
            <div v-if="item.data.cepremamt">
              <span style="color: #ffa500"
                >已墊繳本金：{{
                  Number(item.data.cepremamt) | numberFormat
                }}元</span
              >
            </div>
          </div>
          <div v-else-if="item.data.isPureSubContract">
            <div>
              <span class="text-gray">
                <strong>純附約</strong>
              </span>
              <div>
                {{ `${item.data.companyshortname}/${item.data.policynumber}` }}
              </div>
              {{ item.data.productname
              }}{{ item.data.prodid ? `(${item.data.prodid})` : "" }}
            </div>
            <div style="color: #ffa500" v-if="item.data.cerdjobc_nm">
              職業類別：{{ item.data.cerdjobc_nm }}
            </div>
          </div>
          <div v-else>
            <div style="margin-left: 1em; text-indent: -1em">
              <span style="text-shadow: 0px 1px grey" class="text-gray">
                <strong>└</strong>
              </span>
              <span
                >{{ item.data.productname
                }}{{ item.data.prodid ? `(${item.data.prodid})` : "" }}</span
              >
            </div>
            <div
              style="color: #ffa500; margin-left: 1em; "
              v-if="item.data.cerdjobc_nm "
            >
              職業類別：{{ item.data.cerdjobc_nm }}
            </div>
          </div>
        </template>
        <template slot="applicant" scope="item">
          <span 
            v-if="item.data.apcid != ''" 
            @click="routeToCustDetail(item.data.apcid, item.data.applicant)" 
            class="link text-underline">
            {{ item.data.applicant | truncate }}
          </span>
        </template>
        <template slot="insuredpersonname" scope="item">
          <div
            @click="routeToCustDetail(item.data.insuredpersonid ,item.data.insd_name)"
            class="link text-underline"
          >
            {{ item.data.insd_name | truncate }}
          </div>
        </template>
        <template slot="year" scope="item">
          {{ item.data.paymentway == "躉繳" && item.data.producttype == "2" ? "--" : item.data.year.padLeft(2, "0") }}
        </template>
        <template slot="amountofinsurance" scope="item">
          <div
            v-if="item.data.schemename && item.data.quantity"
            class="text-right pre-formatted"
          >
            {{ `計畫${item.data.schemename}：` }}
            {{
              item.data.schemename && item.data.schemename.includes("_1")
                ? ``
                : `日額`
            }}
            {{ `${item.data.quantity}元` }}
          </div>
          <div v-else class="text-right">
            {{ item.data.amountofinsurance }}
          </div>
        </template>
        <template slot="bknm" scope="item">
          <div v-if="item.data.premium">
            {{ item.data.money }} {{ item.data.premium | numberFormat }}
          </div>
          <div>
            {{
              `${item.data.paymentway}${
                item.data.paymenttype ? `/${item.data.paymenttype}` : ""
              }`
            }}
          </div>
          <div v-if="item.data.bknm || item.data.card_acnt_no">
            {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
          </div>
        </template>
        <template slot="bnf" scope="item">
          <div v-if="item.data.cebnfkd && item.data.cebnfnm">
            <div v-for="(key, index) in item.data.cebnfkd" :key="index">
              {{
                `${translate.cebnfkd[key]}：${item.data.cebnfnm[index]}${
                  Math.round(item.data.rato[index]) == 0 ||
                  Math.round(item.data.rato[index]) == 100
                    ? ""
                    : Math.round(item.data.rato[index]) + "%"
                }`
              }}
            </div>
          </div>
          <div v-else>一一</div>
        </template>
        <template slot="isprimarycontract" scope="item">
          <div>
            {{ getCepremamt(item.data.infcd, item.data.isprimarycontract) }}
          </div>
          <div>
            <span
              v-if="item.data.med_exam == '2' && item.data.isprimarycontract"
              :style="{
                'font-size': '15px',
                color: '#f58818'
              }"
              >(弱體件)</span
            >
          </div>
        </template>
        <template slot="action" scope="item">
          <div class="dropdown" v-if="item.data.canEdit && item.data.canDelete">
            <a
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="btn btn-icon btn-default btn-sm"
              role="button"
            >
              <i class="icon-more"></i>
            </a>
            <div class="dropdown-menu">
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="
                  toUpdate(item.data.insuredpersonid, item.data.policynumber)
                "
              >
                修改家庭型
              </a>
              <a
                class="dropdown-item text-red text-underline"
                @click="doDelete(item.data)"
                >刪除</a
              >
            </div>
          </div>

          <div v-else-if="item.data.canEdit">
            <a
              role="button"
              class="text-green text-underline"
              @click="
                toUpdate(item.data.insuredpersonid, item.data.policynumber)
              "
            >
              修改
              <br />
              家庭型
            </a>
          </div>
          <div v-else-if="item.data.canDelete">
            <a
              role="button"
              class="text-red text-underline"
              @click="doDelete(item.data)"
              >刪除</a
            >
          </div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import CommonMixins from "../common";
import { deleteSelfInputPolicyNumber } from "@/service";

const { moment, _ } = window;
export default {
  mixins: [InsuranceMixins, CommonMixins],
  methods: {
    isInputBySelf(b015plcno) {
      return !!b015plcno;
    },
    isHomeTypePolicy(prodid) {
      return [
        "1G",
        "A3",
        "A8",
        "A9",
        "AE",
        "AJ",
        "AL",
        "AO",
        "AQ",
        "AT",
        "C2",
        "C3",
        "D2",
        "D6",
        "HF2",
        "HF3",
        "HFB",
        "HFC",
        "LQ2",
        "LQ3",
        "MU2",
        "MU3",
        "OD2",
        "OD3",
        "PG2",
        "PG3",
        "1G_",
        "2G_",
        "3G_",
        "4V_",
        "6V_",
        "7V_",
        "8AF_",
        "8DM_",
        "8HA_",
        "8IG_",
        "A3_",
        "A8_",
        "A81_",
        "A9_",
        "A91_",
        "AD_",
        "AD2_",
        "AE_",
        "AG_",
        "AI_",
        "AJ_",
        "AL_",
        "AN_",
        "AN1_",
        "AO_",
        "AO1_",
        "AQ_",
        "AQ1_",
        "AS_",
        "AT_",
        "AV_",
        "B4_",
        "B7_",
        "C2_",
        "C3_",
        "C8_",
        "C9_",
        "D2_",
        "D3_",
        "D5_",
        "D6_"
      ].some((x) => x == prodid);
    },
    toUpdate(csid, plcno) {
      const timer = setInterval(() => {
        if (this.options.families.length) {
          let family = window._.find(this.options.families, { csidno: csid });
          localStorage.insurances = JSON.stringify([]);
          localStorage.familyDatas = JSON.stringify([
            {
              csid,
              plcno,
              ...window._.pick(family, ["sex", "name", "age"])
            }
          ]);
          this.$router.push({
            name: "add-contract-family-relation"
          });
          clearInterval(timer);
        }
      }, 300);
    },
    async doDelete(data) {
      const productName = `${data.policynumber} ${data.productname} ${data.prodid}`;
      const messageBuilder = data.isprimarycontract
        ? this.buildDeleteMessage
        : this.buildDeleteSubMessage;
      await this.$deleteConfirm(messageBuilder(productName));
      await this.deleteSuccessHandler(
        deleteSelfInputPolicyNumber(
          this.$store.state.userInfo.id,
          data.policynumber
        )
      );
      this.isLoading = true;
      this.$bus.emit(
        "cathay-life-insurance.get",
        () => (this.isLoading = false)
      );
    },
    isPrimaryShow(primary) {
      return primary.policyinfolist.some((data) => this.isShow(primary, data));
    },
    isSubContractShow(primary, data) {
      return this.isHomeTypePolicy(data.prodid);
    },
    isShow(primary, data) {
      console.log(primary.insuredpersonname);
      return (
        this.isHomeTypePolicy(data.prodid) ||
        this.isInputBySelf(data.b015plcno) ||
        data.insuredpersonname
      );
    },
    classNm(isprimarycontract) {
      let rAry = "bg-gray";
      if (isprimarycontract) {
        rAry = "bg-white";
      }
      return rAry;
    }
  },
  computed: {
    modify() {
      return this.$route.query.modify
        ? this.$route.query.modify.split(",")
        : [];
    },
    primaryKeyByNumber() {
      return _.keyBy(
        this.datas
          .map((person) =>
            person.majorpolicyinfolist.map((primary) =>
              primary.policyinfolist.map((data) => ({
                ...data,
                isPrimaryContract: !!data.isprimarycontract,
                policynumber: primary.policynumber
              }))
            )
          )
          .flat()
          .flat()
          .filter((x) => x.isPrimaryContract),
        "policynumber"
      );
    },
    proccessDatas() {
      let datas = this.datas
        .map((person) =>
          person.majorpolicyinfolist
            .filter((x) => x.insidefamily)
            .map((primary) => {
              // 掛在他人下面的主約
              const hasPrimaryContractButNotInside = false;
              // primary.hasprimarycontract &&
              // primary.policyinfolist.every((x) => !x.isprimarycontract);
              const primaryData = hasPrimaryContractButNotInside
                ? this.primaryKeyByNumber[primary.policynumber]
                : primary.policyinfolist[0];
              return primary.policyinfolist.map((data) => {
                const isPrimaryContract = !!data.isprimarycontract;
                const isPureSubContract =
                  !primary.hasprimarycontract && !data.isprimarycontract;
                const isSubContract = !isPrimaryContract && !isPureSubContract;
                const isInputBySelf = this.isInputBySelf(data.b015plcno);
                return Object.assign({}, data, {
                  insuredpersonname: person.insuredpersonname,
                  insuredpersonid: person.insuredpersonid,
                  companyshortname: primary.companyshortname,
                  producttype: primary.producttype,
                  policynumber: primary.policynumber,
                  apcid: primary.apcid,
                  applicant: primary.applicant,
                  c111_apc : primary.c111_apc,
                  paymenttype: primary.paymenttype,
                  card_acnt_no: primary.card_acnt_no,
                  bknm: primary.bknm,
                  trClassName: this.modify.includes(primary.policynumber)
                    ? "bg-orange"
                    : this.classNm(data.isprimarycontract),
                  isPrimaryContract,
                  isPureSubContract,
                  isSubContract,
                  isShow: isPrimaryContract
                    ? this.isPrimaryShow(primary)
                    : isSubContract
                    ? this.isSubContractShow(primary, data)
                    : this.isShow(primary, data),
                  canEdit: this.isHomeTypePolicy(data.prodid),
                  canDelete: !isSubContract && isInputBySelf,
                  isInputBySelf,
                  sortProductname: this.mergeString(primary.policynumber),
                  sortApplicant: this.mergeString(
                    primary.applicant,
                    primary.policynumber
                  ),
                  sortInsuredpersonname: this.mergeString(
                    primaryData.insd_name,
                    primary.policynumber
                  ),
                  sortInsuranceADDate: this.mergeString(
                    moment(primaryData.insurancedate).getADDate(),
                    primary.policynumber
                  ),
                  sortBknm: this.mergeString(
                    // 沒有數字可以被放一起
                    !primaryData.premium ? "" : "_",
                    primaryData.money,
                    // 左邊補0讓文字可以被排序
                    primaryData.premium.padLeft(20, "0"),
                    primary.policynumber
                  ),
                  sortIsprimarycontract: this.mergeString(
                    this.getCepremamt(
                      primaryData.infcd,
                      primaryData.isprimarycontract
                    ),
                    primary.policynumber
                  )
                  // sortInit: this.mergeString(personIndex, isInputBySelf ? 1 : 0, primary.policynumber),
                });
              });
            })
        )
        .flat()
        .flat()
        .filter((x) => x.isShow  && x.relation =='本人');
      const { _ } = window;
      const MASTER_CONTRACT = true;
      const relationOrder = _.invert(["本人"]);

      const findRelationInDatas = (relation) =>
        _.filter(datas, {
          isPrimaryContract: MASTER_CONTRACT,
          relation
        });
      // 本人主約
      const myselfContracts = findRelationInDatas("本人");

      // 附約
      let subContracts = _.reject(datas, {
        isPrimaryContract: MASTER_CONTRACT
      });

      // 取出屬於這張單的內容，"並從原資料中移除"
      const pickBelongContract = (policynumber) => (datas) =>
        _.remove(datas, { policynumber: policynumber });
        let aaa = myselfContracts
        .reduce((result, myselfContract) => {
          const pickBelongThisContract = pickBelongContract(
            myselfContract.policynumber
          );
          const thisPartContracts = []
              // 這張單的本人主約
              .concat(myselfContract)
              // 屬於這張單的附約
              .concat(
                _.map(
                  _.groupBy(
                    pickBelongThisContract(subContracts),
                    "policynumber"
                  ),
                  (datas) => _.orderBy(datas, (x) => relationOrder[x.relation])
                ).flat()
              )
              .map(x => ({
                ...x,
                sortInsuredpersonname: this.mergeString(
                  myselfContract.insd_name,
                  myselfContract.policynumber
                ),
                sortBknm: this.mergeString(
                  // 沒有數字可以被放一起
                  !myselfContract.premium ? "" : "_",
                  myselfContract.money,
                  // 左邊補0讓文字可以被排序
                  myselfContract.premium.padLeft(20, "0"),
                  myselfContract.policynumber
                ),
                sortInsuranceADDate: this.mergeString(
                  moment(myselfContract.insurancedate).getADDate(),
                  myselfContract.policynumber
                )
              }))
              console.log(thisPartContracts)
          return result.concat(thisPartContracts)
        }, [])
        .concat(subContracts);
        console.log(aaa)
      return aaa
      // return arr;
    }
  }
};
</script>
